import { CrystalMark } from '@/assets/icons';
import styles from './MarketHero.module.scss';

export function MarketHero() {
  return (
    <div className={styles.hero}>
      <CrystalMark size={56} float className={styles.crystal} />
      <div className={styles.text}>
        <h1>Stars &amp; Premium</h1>
        <p>Buy stars or telegram premium instantly, for yourself, or any of your friends.</p>
      </div>
    </div>
  );
}
